export function findData(id) {
  return {
    type: '@logsdescarregamentositem/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@logsdescarregamentositem/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@logsdescarregamentositem/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@logsdescarregamentositem/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@logsdescarregamentositem/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@logsdescarregamentositem/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@logsdescarregamentositem/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@logsdescarregamentositem/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@logsdescarregamentositem/RECORD_FILTERING',
    payload: { params },
  };
}

export function setPresetAndProduto(preset, produto) {
  return {
    type: '@logsdescarregamentositem/SET_PRESET_PRODUTO',
    payload: { preset, produto },
  };
}
